import React from "react";
import styled from "styled-components";

export const h2 = (props) => <StyledH2 {...props} />;
export const p = (props) => <StyledP {...props} />;

export const span = (props) => <StyledSpan {...props} />;

const StyledH2 = styled.h2`
  && {
    text-align: center;
    font-family: "Corisande Bold", Arial, Tahoma, sans-serif;
    color: #222;
    font-size: 40px;
    font-weight: 400px;
  }
`;

const StyledP = styled.p`
  && {
    font-family: "Corisande Bold", Arial, Tahoma, sans-serif;
    color: #222;
    font-size: 18px;
    font-weight: ${(props) => props.weight || 300};
  }
`;

const StyledSpan = styled.span`
  && {
    padding: ${(props) => props.padding || "10px 0px"};
    font-family: "Corisande Bold", Arial, Tahoma, sans-serif;
    color: #222;
    font-size: 18px;
    font-weight: ${(props) => props.weight || 300};
  }
`;
